<template>
  <el-container>
    <el-header style="height: 20px;">
      <span class="company" v-if="currentUser.userType === 1">亲爱的：{{currentUser.person.name}}</span>
      <span class="company" v-if="currentUser.userType === 2">亲爱的：{{currentUser.customer.name}}</span>
      <span class="company" style="margin-left: 10px">当前公司：{{saleOrgName}}</span>
      <el-button class="but" size="small" style="background: white;color: rgb(240, 57, 74);" @click="changeCompany">点此切换公司</el-button>
      <el-button class="but" size="small" style="margin-left: -10px;background: white;color: rgb(240, 57, 74);" @click="logout">退出登录</el-button>
    </el-header>
    <el-divider class="div_top"></el-divider>
    <el-main class="main">
      <el-card class="card">
        <div slot="header" class="text" style="height: 15px;">
          个人档案
        </div>
        <div>
          <el-tabs v-model="activeName">
            <el-tab-pane label="我的信息" name="first">
              <div>
                <div style="text-align: center">
                  <el-avatar :size="120" src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"></el-avatar>
                </div>
                <el-form label-width="110px">
                  <el-form-item class="form-item-style">
                    <div slot="label">
                      <i class="el-icon-user"></i>登录账号：
                    </div>
                    {{ currentUser.username }}
                  </el-form-item>
                  <el-form-item class="form-item-style">
                    <div slot="label">
                      <i class="el-icon-tickets"></i>用户姓名：
                    </div>
                    <span v-if="currentUser.userType === 1">{{currentUser.person.name}}</span>
                    <span v-if="currentUser.userType === 2">{{currentUser.customer.name}}</span>
                  </el-form-item>
                  <el-form-item class="form-item-style">
                    <div slot="label">
                      <i class="el-icon-cloudy"></i>所属组织：
                    </div>
                    {{ currentUser.tenant.tenantName}}
                  </el-form-item>
                  <el-form-item class="form-item-style">
                    <div slot="label">
                      <i class="el-icon-postcard"></i>所属角色：
                    </div>
                    {{ currentUser.roleNames }}
                  </el-form-item>
                  <el-form-item class="form-item-style">
                    <div slot="label">
                      <i class="el-icon-date"></i>创建日期：
                    </div>
                    {{ currentUser.createTime }}
                  </el-form-item>
                </el-form>
              </div>
            </el-tab-pane>
            <el-tab-pane label="修改密码" name="second">
              <el-form label-width="100px" ref="pwdForm" :rules="pwdRules" :model="pwdForm">
                <el-form-item label="原密码：" prop="oldPwd">
                  <el-input v-model="pwdForm.oldPwd" show-password/>
                </el-form-item>
                <el-form-item label="新密码：" prop="newPwd">
                  <el-input v-model="pwdForm.newPwd" show-password/>
                </el-form-item>
                <el-form-item label="确认密码：" prop="confirmPwd">
                  <el-input v-model="pwdForm.confirmPwd" show-password/>
                </el-form-item>
              </el-form>
              <div style="text-align: right">
                <el-button class="btn" type="primary" size="small" @click="changePwd" :loading="pwdBtnLoading">确认修改</el-button>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-card>
    </el-main>
  </el-container>
</template>

<script>
import { changePassword } from '@/api/login'
export default {
  data () {
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('确认密码不能为空'));
      } else if (value === this.pwdForm.oldPwd) {
        callback(new Error('新密码不能与原密码一致'));
      } else if (value !== this.pwdForm.newPwd) {
        callback(new Error('确认密码与新密码不一致'));
      } else {
        callback();
      }
    };
    return {
      currentUser: {
        userType:'',
        person:{
          name:''
        },
        customer:{
          name:''
        },
        tenant:{
          tenantName:''
        },
        roleNames:'',
        createTime:''
      },
      saleOrgName:'',
      activeName: 'first',
      pwdForm: {
        oldPwd: '',
        newPwd: '',
        confirmPwd: ''
      },
      msgRules: {
        nickname: [
          { required: true, message: "用户昵称不能为空", trigger: "blur" }
        ]
      },
      pwdRules: {
        oldPwd: [
          { required: true, message: "原密码不能为空", trigger: "blur" }
        ],
        newPwd: [
          { required: true, message: "新密码不能为空", trigger: "blur" },
          { min: 6, max: 12,message: "新密码长度在6~12个字符", trigger: "blur"},
          { validator: validatePass, trigger: 'blur' }
        ],
        confirmPwd: [
          { required: true, validator: validatePass, trigger: 'blur' }
        ],
      },
      msgBtnLoading: false,
      pwdBtnLoading: false,
    };
  },
  mounted() {
    //获取当前用户
    this.currentUser = this.$store.getters.currentUser
    //获取当前销售组织名称
    this.saleOrgName = sessionStorage.getItem("saleOrgName")
    //获取所属角色
    this.getRoleNames(this.currentUser.roles)
  },
  methods: {
    changeCompany(){
      this.$confirm('确定要切换公司么？', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push({path: '/system/user/company'})
      }).catch(() => {

      });
    },
    getRoleNames(roles) {
      let names = "";
      for (let i = 0; i < roles.length - 1; i++) {
        names = names + roles[i].roleName + "，";
      }
      names = names + roles[roles.length - 1].roleName
      this.currentUser.roleNames = names
    },
    changePwd() {
      this.$refs["pwdForm"].validate(valid => {
        if (valid) {
          this.pwdBtnLoading = true;
          //原密码
          this.currentUser.password = this.pwdForm.oldPwd;
          //新密码
          this.currentUser.newPassword = this.pwdForm.newPwd;

          changePassword(this.currentUser).then(res => {
            this.$modal.msgSuccess("密码修改成功,请重新登录");
            this.pwdBtnLoading = false;
            this.$store.dispatch("LogOut").then(() => {
              this.$store.dispatch("ClearMenu");
              this.$router.push({ path: this.redirect || "/login" }).catch(()=>{});
            }).catch(() => {});
          }).catch(err => {
            console.log(err)
            this.pwdBtnLoading = false;
          });
        }
      });
    },
    logout() {
      let that = this;
      that.$modal.confirm('是否确认退出小禾订货平台？').then(function() {
        that.$store.dispatch("LogOut").then(() => {
          sessionStorage.clear()
          that.$store.dispatch("ClearMenu");
          that.$router.push({ path: that.redirect || "/login" }).catch(()=>{});
        }).catch(() => {});
      })
    },
  }
};
</script>
<style>
  .main{
    margin-top: -10px;
  }
  .company{
    font-size: 14px;
    color:rgb(143, 143, 143)
  }
  .but{
    font-size: 14px;
    border: none;
    font-weight: 600;
  }
  .div_top{
    margin: 12px 0;
  }
  .text{
    display: flex;
    font-size: 20px;
    font-weight: 700;
    line-height: 25px;
    letter-spacing: 1px;
    text-align: left;
  }
  .card{
    width: 400px;
    margin-top: 10px;
  }
  .form-item-style {
    border-bottom: 1px solid;
    border-bottom-color: #DCDFE6;
    height: 30px;
  }
</style>
